import React from 'react'
import './Extras.scss';
//import Rebase  from 're-base'
import {debounce} from 'throttle-debounce'
import ReactDOM from 'react-dom'
import {Editor, EditorState, convertFromRaw, convertToRaw} from 'draft-js'
import Toggle from 'react-toggle'
import WYSIWYG from '../WYSIWYG'

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
}

class Extras extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dumb_note: false,
      editorState: EditorState.createEmpty()
    }
    this.onNotesChange = this.onNotesChange.bind(this)
  }

  componentDidMount () {
    if (this.props.formData && this.props.formData.notes) this.setState({dumb_note: true})
  }

  onChangeCheck() {
    this.setState({dumb_note: !this.state.dumb_note})
  }

  onNotesChange (editorState) {
    const rawDraftContentState = JSON.stringify(convertToRaw(editorState.getCurrentContent()));
    const data = {
      notes: rawDraftContentState
    }
    this.props.onChange(data)
  }

  render() {

    const notes = this.props.formData && this.props.formData.notes ? this.props.formData.notes : null

    return (
      <div className='notes'>

        <div className="extras-checkbox">
          <label className='control-label'>Notes</label><br/>
          <Toggle checked={this.state.dumb_note} onChange={this.onChangeCheck.bind(this)} />
        </div>

        {this.state.dumb_note &&
          <div className="form-group m-t-md">

            <WYSIWYG action={this.onNotesChange} content={notes} />
          </div>
        }
      </div>
    )
  }
}

export default Extras;



// WEBPACK FOOTER //
// ./src/views/components/Extras/index.js